var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"size":_vm.logoSize,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"App Logo"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f281b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLogo.vue
// module id = UC7k
// module chunks = 1